enum ExternalLinks {
  FAQ_WHAT_IS_WORKSPACE = 'https://leadercrm.zendesk.com/hc/en-us/articles/8071775026193-What-is-a-workspace-',
  FAQ_GENERAL = 'https://leadercrm.zendesk.com/hc/en-us',
  BOOK_A_DEMO = 'https://calendar.ai/leader/demo',
  CONTACT_US = 'https://leader.zendesk.com/hc/en-us/requests/new',
  ZAPIER_LEADER = 'https://zapier.com/apps/leader-crm/integrations',
}

export default ExternalLinks;
